<div class="main-content">
	<div class="container-fluid">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header card-header-{{color}}-6 d-flex justify-content-between align-items-center">
					<h4 class="card-title mb-0" (click)="back()">
						<i class="material-icons">arrow_left</i>
						Payment run
					</h4>
					<a routerLink="/vendors-pending-payment-runs" class="btn btn-sm btn-light">Pending payment runs</a>
				</div>
				<div class="card-body" [class.card-body--sticky-footer]="showStickyFooter">

					<!-- Collapsed-filter summary: shows after a successful search. Click Edit to reopen. -->
					<div class="filters-collapsible__summary" *ngIf="!filtersExpanded">
						<span class="filters-collapsible__summary-text">
							<i class="fa fa-filter"></i>
							{{ paymentForm.get('supplierIds')?.value?.length || 0 }} vendor(s)
							· Due by {{ paymentForm.get('paymentDueDate')?.value | date:'mediumDate' }}
							· {{ includeDiscount === '1' ? 'with' : 'without' }} discounts
						</span>
						<button type="button" class="btn btn-outline-secondary btn-sm filters-collapsible__edit-btn" (click)="filtersExpanded = true">
							<i class="fa fa-pencil"></i> Edit filters
						</button>
					</div>

					<form [formGroup]="paymentForm" class="payment-run-form" *ngIf="filtersExpanded">

						<!-- Collapse button — only shows once results exist, otherwise there's
							 nothing below to look at so collapsing would just produce dead air. -->
						<div class="payment-run-form__header" *ngIf="data?.success && (checklist | keyvalue).length">
							<span class="payment-run-form__header-label">Filters</span>
							<button type="button" class="payment-run-form__collapse" (click)="filtersExpanded = false" title="Hide filters">
								<i class="fa fa-chevron-up"></i> Hide
							</button>
						</div>

						<div class="row mb-3 align-items-end">
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Vendor currency</mat-label>
									<mat-select formControlName="currency" (selectionChange)="reloadBankAccounts()">
										<mat-option *ngFor="let curr of currencies" [value]="curr.currabrev">{{ curr.currabrev }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Pay in currency</mat-label>
									<mat-select formControlName="override_currency" (selectionChange)="reloadBankAccounts()">
										<mat-option value="">Same as vendor</mat-option>
										<mat-option *ngFor="let curr of currencies" [value]="curr.currabrev">{{ curr.currabrev }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Bank account</mat-label>
									<mat-select formControlName="bankaccount">
										<mat-option *ngFor="let bank of bankAccounts" [value]="bank.accountcode">{{ bank.bankaccountname }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Posting date</mat-label>
									<input matInput formControlName="postingDate" [matDatepicker]="postingDatePicker" />
									<mat-datepicker-toggle matSuffix [for]="postingDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #postingDatePicker></mat-datepicker>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>First check #</mat-label>
									<input matInput formControlName="checkNumber" placeholder="1001" (change)="onCheckNumberChange()" />
								</mat-form-field>
							</div>
						</div>

						<div class="row mb-3 align-items-end">
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Vendors</mat-label>
									<mat-select formControlName="supplierIds" multiple>
										<div class="vendor-select-search" (click)="$event.stopPropagation()">
											<input
												type="text"
												placeholder="Search vendors"
												[(ngModel)]="vendorSelectSearch"
												[ngModelOptions]="{standalone: true}"
												(keydown)="$event.stopPropagation()"
												(keydown.enter)="$event.preventDefault()"
											/>
											<div class="vendor-select-search__actions">
												<button type="button" (click)="selectAllVendorSelectOptions(); $event.stopPropagation()">Select all</button>
												<button type="button" (click)="selectNoVendorSelectOptions(); $event.stopPropagation()">Select none</button>
											</div>
										</div>
										<mat-option *ngFor="let v of searchedVendorSelectList" [value]="v.supplierid">
											{{ v.supplierid }} — {{ v.suppname }}
										</mat-option>
										<div class="vendor-select-empty" *ngIf="!searchedVendorSelectList.length">No vendors match.</div>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Vendor type</mat-label>
									<mat-select formControlName="vendorType" (selectionChange)="onVendorTypeFilterChange()">
										<mat-option value="">All</mat-option>
										<mat-option *ngFor="let type of vendorTypes" [value]="type.code">{{ type.description }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Due by</mat-label>
									<input matInput formControlName="paymentDueDate" [matDatepicker]="dueDatePicker" />
									<mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #dueDatePicker [startAt]="paymentForm.get('paymentDueDate')?.value"></mat-datepicker>
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="outline" class="w-100 pr-outline-field">
									<mat-label>Disc. eligible</mat-label>
									<mat-select [(ngModel)]="includeDiscount" [ngModelOptions]="{standalone: true}">
										<mat-option value="0">No</mat-option>
										<mat-option value="1">Yes</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-2 d-flex flex-column justify-content-end gap-2 pr-action-col">
								<mat-slide-toggle formControlName="includeInactiveVendors" (change)="loadVendorSelectList()">Include inactive</mat-slide-toggle>
								<button type="button" class="btn btn-primary w-100" (click)="searchChecks()" [disabled]="searching">
									<span *ngIf="searching" class="btn-inline-spinner" aria-hidden="true"></span>
									<i *ngIf="!searching" class="fa fa-search"></i> {{ searching ? 'Searching…' : 'Search' }}
								</button>
								<!-- Reconciliation tools (statement snapshot from payment_run). Hidden by default; flip showStatementTools to re-enable. -->
								<ng-container *ngIf="showStatementTools">
									<button type="button" class="btn btn-outline-warning w-100 mt-2" (click)="searchStatement()" [disabled]="searching" title="Load the reconciled vendor statement snapshot (payment_run)">
										<i class="fa fa-file-text-o"></i> Load statement view
									</button>
									<!-- Loads + selects Past Due + Current = the statement's Total Amount Due (credits net against invoices). -->
									<button type="button" class="btn btn-warning w-100 mt-2" (click)="selectAmountDue()" [disabled]="searching" title="Load and select what's actually due now (Past Due + Current = Total Amount Due)">
										<i class="fa fa-check-square-o"></i> Select Amount Due
									</button>
								</ng-container>
							</div>
						</div>

						<div class="text-muted small" *ngIf="loadingVendors">Loading vendors…</div>
						<div class="text-warning small" *ngIf="!loadingVendors && !filteredVendorSelectList.length">No vendors match the current type filter.</div>

					</form>

				<!-- Phase stepper — orients the clerk; previous steps are clickable to navigate back. -->
				<div class="phase-stepper" [attr.data-phase]="currentPhase">
					<div class="phase-step"
						[class.phase-step--active]="currentPhase === 'select'"
						[class.phase-step--done]="currentPhase !== 'select'"
						[class.phase-step--clickable]="canNavigateToPhase('select')"
						[attr.role]="canNavigateToPhase('select') ? 'button' : null"
						[attr.tabindex]="canNavigateToPhase('select') ? 0 : null"
						[attr.title]="canNavigateToPhase('select')
							? (currentPhase === 'posted' ? 'Start a new payment run' : 'Back to invoice selection')
							: null"
						(click)="onPhaseClick('select')"
						(keydown.enter)="onPhaseClick('select')"
						(keydown.space)="onPhaseClick('select'); $event.preventDefault()">
						<span class="phase-step__dot">1</span>
						<span class="phase-step__label">Select invoices</span>
					</div>
					<div class="phase-step__sep"></div>
					<div class="phase-step"
						[class.phase-step--active]="currentPhase === 'review'"
						[class.phase-step--done]="currentPhase === 'posted'"
						[class.phase-step--clickable]="canNavigateToPhase('review')"
						[attr.role]="canNavigateToPhase('review') ? 'button' : null"
						[attr.tabindex]="canNavigateToPhase('review') ? 0 : null"
						(click)="onPhaseClick('review')"
						(keydown.enter)="onPhaseClick('review')"
						(keydown.space)="onPhaseClick('review'); $event.preventDefault()">
						<span class="phase-step__dot">2</span>
						<span class="phase-step__label">Review checks</span>
					</div>
					<div class="phase-step__sep"></div>
					<div class="phase-step" [class.phase-step--active]="currentPhase === 'posted'">
						<span class="phase-step__dot">3</span>
						<span class="phase-step__label">Post</span>
					</div>
				</div>

				<!-- Run context — what run am I looking at? -->
				<div class="run-context" *ngIf="loadedJournal != null || hasGeneratedChecks || workflow === PaymentRunWorkflow.Posted">
					<div class="run-context__field">
						<span class="run-context__label">Run</span>
						<span class="run-context__value">#{{ responsePayload?.journal ?? loadedJournal ?? postedResult?.journal ?? '—' }}</span>
					</div>
					<div class="run-context__field" *ngIf="currentPhase !== 'posted'">
						<span class="run-context__label">Status</span>
						<span class="run-context__value run-context__value--pending">Pending — not posted</span>
					</div>
					<div class="run-context__field" *ngIf="currentPhase === 'posted'">
						<span class="run-context__label">Status</span>
						<span class="run-context__value run-context__value--posted">Posted</span>
					</div>
					<div class="run-context__field" *ngIf="hasGeneratedChecks">
						<span class="run-context__label">Checks</span>
						<span class="run-context__value">{{ checkCount }}</span>
					</div>
					<div class="run-context__field" *ngIf="stickyFooterTotal || totalDue">
						<span class="run-context__label">Total</span>
						<span class="run-context__value">${{ (stickyFooterTotal || totalDue) | number:'1.2-2' }}</span>
					</div>
				</div>

				<ng-container *ngIf="bannerMessage">
					<div class="success-message">
						<i class="fa fa-check-circle"></i>
						{{ bannerMessage }}
						<a
							*ngIf="savedForReviewJournal != null || workflow === PaymentRunWorkflow.Posted"
							routerLink="/vendors-pending-payment-runs"
							class="ml-2 font-weight-bold"
							>Pending payment runs</a>
					</div>
					<p *ngIf="workflow === PaymentRunWorkflow.Posted && postedResult?.summary" class="small text-muted mb-2 mt-2">
						{{ postedResult.summary.currency }}
						{{ postedResult.summary.totalAmount | number: '1.2-2' }}
						· {{ postedResult.summary.vendorCount }} vendor(s)
						· {{ postedResult.summary.paymentCount }} payment line(s)
					</p>
				</ng-container>

				<div
					*ngIf="workflow === PaymentRunWorkflow.Posted && postedResult && !hasGeneratedChecks"
					class="alert alert-success mb-3"
					role="status"
				>
					<p class="mb-1"><strong>Payment run posted</strong> — journal {{ postedResult.journal }}.</p>
					<p *ngIf="postedResult.summary" class="small text-muted mb-0">
						{{ postedResult.summary.currency }} {{ postedResult.summary.totalAmount | number: '1.2-2' }}
						· {{ postedResult.summary.vendorCount }} vendor(s)
						· {{ postedResult.summary.paymentCount }} payment line(s)
					</p>
					<p *ngIf="!postedResult.summary" class="small text-muted mb-0">Use Pending payment runs for history; PDF was from the preview before post.</p>
				</div>

				<!-- Generate loader — shown while PDF generation is in flight. -->
				<div class="generate-loader" *ngIf="workflow === PaymentRunWorkflow.Generating">
					<div class="generate-loader__spinner">
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					</div>
					<div class="generate-loader__text">Generating checks&hellip;</div>
					<div class="generate-loader__skel-grid">
						<div class="generate-loader__skel-card" *ngFor="let n of [1,2,3,4]">
							<div class="skel skel--title"></div>
							<div class="skel skel--line"></div>
							<div class="skel skel--amount"></div>
							<div class="skel skel--line skel--short"></div>
						</div>
					</div>
				</div>

				<!-- Posting progress overlay — sits above check cards, can't be missed. -->
				<div class="posting-overlay" *ngIf="postingProgress">
					<div class="posting-overlay__inner">
						<span class="spinner-border text-light posting-overlay__spinner" role="status" aria-hidden="true"></span>
						<div class="posting-overlay__text">
							Posting payments&hellip;
							<span class="posting-overlay__count">{{ postingProgress.current }} of {{ postingProgress.total }}</span>
						</div>
						<div class="posting-overlay__bar-wrap">
							<div class="posting-overlay__bar-fill" [style.width.%]="postingProgress.total ? (postingProgress.current * 100 / postingProgress.total) : 0"></div>
						</div>
						<div class="posting-overlay__detail" *ngIf="postingProgress.skipped">
							{{ postingProgress.skipped }} already posted — skipping
						</div>
					</div>
				</div>

				<ng-container *ngIf="hasGeneratedChecks">
					<p class="text-muted small mb-2" *ngIf="workflow === PaymentRunWorkflow.Posted">
						This run is posted. Check layout and PDF below match what was sent; use Pending payment runs when you need the list again.
					</p>

					<!-- Check cards — preview-as-stub layout. Responsive grid: 1 col on narrow, 2 wide. -->
					<div class="check-grid">
						<div *ngFor="let check of checks | keyvalue" class="check-card" [class.check-card--posted]="workflow === PaymentRunWorkflow.Posted">
							<div class="check-card__topbar">
								<div class="check-card__num">
									<span class="check-card__num-label">Check</span>
									<!-- checks is an ARRAY after formatChecks(), so keyvalue's key is the
									     array index (0,1,2…) — the ref lives on the element. Legacy object
									     map (no checkNumber property) still falls back to the key. -->
									<span class="check-card__num-value">#{{ check.value.checkNumber || check.key }}</span>
								</div>
								<div class="check-card__date">{{ check.value.check.date }}</div>
							</div>

							<div class="check-card__payee-row">
								<div class="check-card__payee-label">Pay to the order of</div>
								<div class="check-card__payee">{{ check.value.check.payorder }}</div>
							</div>

							<div class="check-card__amount-row">
								<div class="check-card__amount">${{ check.value.check.amount | number: '1.2-2' }}</div>
								<div class="check-card__currency-chip">{{ check.value.postings.Currency }}</div>
							</div>

							<div class="check-card__legal" *ngIf="check.value.check.payword">
								{{ check.value.check.payword }}
							</div>

							<div class="check-card__addr">
								<i class="fa fa-envelope-o check-card__addr-icon"></i>
								<div class="check-card__addr-lines">
									<div *ngFor="let line of (check.value.check.addr || '').split('|')">{{ line }}</div>
								</div>
							</div>

							<div class="check-card__footer">
								<span class="check-card__footer-label">Total paid</span>
								<span class="check-card__footer-value">${{ check.value.postings.AccumBalance | number: '1.2-2' }}</span>
							</div>
						</div>
					</div>
				</ng-container>

					<!-- Empty-state when a search succeeded but produced no payable invoices. -->
					<div *ngIf="data && data.success && currentPhase === 'select' && (!checklist || !(checklist | keyvalue).length)" class="empty-state">
						<i class="fa fa-inbox empty-state__icon"></i>
						<p class="empty-state__title">No payable invoices found.</p>
						<p class="empty-state__hint">Adjust the vendor list, due date, or vendor type filter, then Search again.</p>
					</div>

					<div *ngIf="data && data.success && currentPhase === 'select' && (checklist | keyvalue).length" class="vendor-container" [class.vendor-container--posted]="workflow === PaymentRunWorkflow.Posted">
						<ng-container *ngIf="workflow !== PaymentRunWorkflow.Posted">
					<!-- Top-of-grid "Select all everything" affordance (no column labels — those live per vendor). -->
					<div class="grid-toolbar">
						<label class="grid-toolbar__select-all">
							<input type="checkbox" [checked]="allVendorsSelected()" (change)="setAllVendorsSelection($any($event.target).checked)" />
							<span>Select all across every vendor</span>
						</label>
						<div class="grid-toolbar__row-filters" role="group" aria-label="Invoice and credit filters">
							<label><input type="checkbox" [checked]="globalRowFilters.showInvoices" (change)="applyGlobalRowFilter('showInvoices', $any($event.target).checked)" /> Show invoices</label>
							<label><input type="checkbox" [checked]="globalRowFilters.showCredits" (change)="applyGlobalRowFilter('showCredits', $any($event.target).checked)" /> Show credits</label>
							<label><input type="checkbox" [checked]="globalRowFilters.useInvoices" (change)="applyGlobalRowFilter('useInvoices', $any($event.target).checked)" /> Use invoices</label>
							<label><input type="checkbox" [checked]="globalRowFilters.useCredits" (change)="applyGlobalRowFilter('useCredits', $any($event.target).checked)" /> Use credits</label>
						</div>
					</div>

					<div *ngFor="let vendor of checklist | keyvalue" class="vendor-group card-header mt-0 mb-0" [class.vendor-group--collapsed]="!expandedVendors[vendor.key]" [class.vendor-group--blocked]="vendorBlockedReason(vendor.key)">
						<!-- Statement header figures (only when loaded via "Load statement view"). Matches the vendor statement: Past Due + Current = Total Amount Due. -->
						<div *ngIf="statementSummary[vendor.key] as ss" class="statement-summary" style="display:flex;gap:18px;flex-wrap:wrap;align-items:baseline;padding:10px 14px;margin:0 0 6px;background:#fff8e1;border:1px solid #ffe082;border-radius:6px;font-size:13px;">
							<span><b>Statement</b></span>
							<span>Past Due: <b>{{ ss.past_due | currency }}</b></span>
							<span>Current Due: <b>{{ ss.current_due | currency }}</b></span>
							<span style="font-size:15px;">Total Amount Due: <b>{{ ss.total_amount_due | currency }}</b></span>
							<span style="opacity:.7;">Future: {{ ss.future_due | currency }}</span>
							<span style="opacity:.7;">Account Balance: {{ ss.total_account_balance | currency }}</span>
						</div>
						<!-- Collapsible header strip: select-all + name + counts + total + chevron -->
						<div class="vendor-collapse-strip" (click)="toggleVendor(vendor.key)" role="button" [attr.aria-expanded]="expandedVendors[vendor.key]">
							<label class="vendor-collapse-strip__check" (click)="$event.stopPropagation()" [title]="(vendorChecks[vendor.key] ? 'Deselect' : 'Select') + ' all rows for this vendor'">
								<input
									type="checkbox"
									[(ngModel)]="vendorChecks[vendor.key]"
									(change)="updateGroupCheck(vendor.key)"
									(click)="$event.stopPropagation()"
									[attr.aria-label]="'Select all rows for ' + vendor.value[0]?.suppname" />
							</label>
							<span class="vendor-collapse-strip__chevron" [class.is-open]="expandedVendors[vendor.key]" aria-hidden="true"></span>
							<span class="vendor-collapse-strip__name"><b>{{ vendor.key }}</b> &nbsp;{{ vendor.value[0]?.suppname }}</span>
							<span class="vendor-collapse-strip__meta">
								<span class="vendor-collapse-strip__warn" *ngIf="vendorBlockedReason(vendor.key)" [title]="vendorBlockedReason(vendor.key)">
									<i class="fa fa-exclamation-triangle"></i> Can't post
								</span>
								<span class="vendor-collapse-strip__count">{{ vendorRowSelectedCount(vendor.key) }} / {{ vendor.value.length }} selected</span>
								<span class="vendor-collapse-strip__paid" *ngIf="vendorPaidCount(vendor.value) as paid">{{ paid }} already paid</span>
								<span class="vendor-collapse-strip__count" *ngIf="vendorSearchTerms[vendor.key]">
									{{ vendorSearchMatchCount(vendor.key) }} match{{ vendorSearchMatchCount(vendor.key) === 1 ? '' : 'es' }}
								</span>
								<span class="vendor-collapse-strip__total">${{ vendorTotals[vendor.key] | number:'1.2-2' }}</span>
							</span>
						</div>
						<ng-container *ngIf="expandedVendors[vendor.key]">
						<!-- Inline block reason — fires when net ≤ 0 with selections, prevents Generate. -->
						<div class="vendor-block" *ngIf="vendorBlockedReason(vendor.key)">
							<i class="fa fa-exclamation-triangle"></i>
							<span>{{ vendorBlockedReason(vendor.key) }}</span>
						</div>
						<!-- Compact vendor strip: select-all + date + ref + payment-type chips + remove on one line. -->
						<div class="vendor-strip" [class.vendor-strip--blocked]="vendorBlockedReason(vendor.key)">
							<!-- Per-vendor Select-all lives on the collapse strip above so it's reachable
								 without expanding the group. -->
							<div class="vendor-strip__field">
								<label class="vendor-strip__label">Pay date</label>
								<input type="date" class="vendor-strip__input" [value]="vendorDates[vendor.key]" (change)="onVendorCheckDateChange(vendor.key, parseDate($any($event.target).value))" />
							</div>
							<div class="vendor-strip__field">
								<label class="vendor-strip__label">Ref #</label>
								<input type="text" class="vendor-strip__input vendor-strip__input--narrow" [(ngModel)]="vendorCheckNumbers[vendor.key]" [ngModelOptions]="{standalone: true}" (ngModelChange)="onVendorCheckNumberChange(vendor.key)" />
							</div>
							<div class="vendor-strip__field vendor-strip__field--grow">
								<label class="vendor-strip__label">Pay type</label>
								<div class="vendor-payment-type" role="group" aria-label="Payment type">
									<button type="button" class="vendor-payment-type__option" *ngFor="let method of paymentMethods" [class.vendor-payment-type__option--selected]="vendorPaymentTypes[vendor.key] === method.paymentname" (click)="vendorPaymentTypes[vendor.key] = method.paymentname">
										{{ method.paymentname }}
									</button>
								</div>
							</div>
							<div class="vendor-row-filter" role="group" [attr.aria-label]="'Row filters for ' + vendor.key">
								<label><input type="checkbox" [checked]="vendorRowFilters[vendor.key]?.showInvoices !== false" (change)="onVendorRowFilterChange(vendor.key, 'showInvoices', $any($event.target).checked)" /> Show invoices</label>
								<label><input type="checkbox" [checked]="vendorRowFilters[vendor.key]?.showCredits !== false" (change)="onVendorRowFilterChange(vendor.key, 'showCredits', $any($event.target).checked)" /> Show credits</label>
								<label><input type="checkbox" [checked]="vendorRowFilters[vendor.key]?.useInvoices !== false" (change)="onVendorRowFilterChange(vendor.key, 'useInvoices', $any($event.target).checked)" /> Use invoices</label>
								<label><input type="checkbox" [checked]="vendorRowFilters[vendor.key]?.useCredits !== false" (change)="onVendorRowFilterChange(vendor.key, 'useCredits', $any($event.target).checked)" /> Use credits</label>
							</div>
							<div class="vendor-row-search">
								<i class="fa fa-search" aria-hidden="true"></i>
								<input type="search" [(ngModel)]="vendorSearchTerms[vendor.key]" (ngModelChange)="onVendorSearchChange(vendor.key)" placeholder="Search this vendor" />
								<span *ngIf="vendorSearchTerms[vendor.key]" class="vendor-row-search__count">{{ vendorSearchMatchCount(vendor.key) }}</span>
								<button *ngIf="vendorSearchTerms[vendor.key]" type="button" (click)="clearVendorSearch(vendor.key)" title="Clear search" aria-label="Clear vendor search">
									<i class="fa fa-times"></i>
								</button>
							</div>
							<button class="vendor-strip__remove" (click)="removeVendor(vendor.key)" title="Remove this vendor from the run" aria-label="Remove vendor">
								<i class="fa fa-times"></i>
							</button>
						</div>

							<!-- Per-section column headers — repeat per vendor so they stay near the rows. -->
							<div class="transaction-header">
								<div class="transaction-checkbox"></div>
								<div class="transaction-details">Invoice / Ref</div>
								<div class="transaction-dates">Inv · Due</div>
								<div class="transaction-amounts">Net / Applied</div>
								<div class="transaction-discount">Discount</div>
								<div class="transaction-amount-due">Pay Amt</div>
							</div>

							<div *ngIf="!visibleVendorTransactions(vendor.key, vendor.value).length" class="transaction-empty">
								No rows match the current invoice / credit filters.
							</div>

							<div *ngFor="let transaction of visibleVendorTransactions(vendor.key, vendor.value); let i = index"
								class="transaction-row"
								[class.transaction-row--selected]="transaction.selected"
								[class.transaction-row--alt]="i % 2 === 1"
								[class.transaction-row--credit]="isCreditTxn(transaction)"
								[class.transaction-row--search-match]="transactionMatchesSearch(transaction, vendor.key) && vendorSearchTerms[vendor.key]"
								[ngClass]="{
									'due-soon': isDueSoon(transaction.duedate),
									'discount-available': transaction.discountavail > 0,
									'completed': transaction.bal <= 0,
									'transaction-row--paid': isPaidTxn(transaction)
								}"
								(click)="toggleTxn(transaction, vendor.key, $event)">
								<div class="transaction-checkbox">
									<label class="custom-checkbox">
										<input type="checkbox" [id]="'check-' + transaction.id" [(ngModel)]="transaction.selected" [disabled]="isPaidTxn(transaction)" (click)="$event.stopPropagation()" (change)="updateVendorTotal(vendor.key)" />
										<span class="checkmark"></span>
									</label>
								</div>

								<div class="transaction-details">
									<div class="tr-ref">
										<span class="tr-kind" [class.tr-kind--credit]="isCreditTxn(transaction)">{{ txnTypeLabel(transaction) }}</span>
										<span class="tr-paid-badge" *ngIf="isPaidTxn(transaction)" [title]="paidTxnLabel(transaction) + ' — cannot be added to a check run'">{{ paidTxnLabel(transaction) }}</span>
										<ng-container *ngFor="let seg of highlightSegments(formatTxnRef(transaction), vendor.key)">
											<mark *ngIf="seg.match" class="tr-hit">{{ seg.text }}</mark><span *ngIf="!seg.match">{{ seg.text }}</span>
										</ng-container>
									</div>
									<div class="tr-meta" *ngIf="transaction.suppreference">
										<ng-container *ngFor="let seg of highlightSegments(transaction.typename + ' · #' + transaction.transno, vendor.key)">
											<mark *ngIf="seg.match" class="tr-hit">{{ seg.text }}</mark><span *ngIf="!seg.match">{{ seg.text }}</span>
										</ng-container>
									</div>
									<div class="tr-meta" *ngIf="!transaction.suppreference">
										<ng-container *ngFor="let seg of highlightSegments('#' + transaction.transno, vendor.key)">
											<mark *ngIf="seg.match" class="tr-hit">{{ seg.text }}</mark><span *ngIf="!seg.match">{{ seg.text }}</span>
										</ng-container>
									</div>
								</div>

								<div class="transaction-dates">
									<div class="tr-date"><span class="tr-date__tag">INV</span> {{ formatTxnDate(transaction.trandate) }}</div>
									<div class="tr-date"><span class="tr-date__tag">DUE</span> {{ formatTxnDate(transaction.duedate) }}</div>
								</div>

								<div class="transaction-amounts">
									<div class="tr-amount" [class.tr-amount--neg]="(transaction.ovamount + transaction.ovgst) < 0">
										<span class="tr-amount__tag">Net</span>
										<span class="tr-amount__val">${{ transaction.ovamount + transaction.ovgst | number: '1.2-2' }}</span>
									</div>
									<div class="tr-amount tr-amount--muted">
										<span class="tr-amount__tag">Applied</span>
										<span class="tr-amount__val">${{ transaction.alloc | number: '1.2-2' }}</span>
									</div>
								</div>

								<div class="transaction-discount">
									<div class="tr-money-wrap">
										<span class="currency-indicator">$</span>
										<input class="transaction-discount-input has-prefix" type="text" inputmode="decimal" [(ngModel)]="transaction.disc" (click)="$event.stopPropagation()" (blur)="onMoneyInput(transaction, 'disc', vendor.key)" (ngModelChange)="updateVendorTotal(vendor.key)" />
									</div>
									<div class="tr-disc-date" *ngIf="transaction.discdate && transaction.discountavail > 0">by {{ formatTxnDate(transaction.discdate) }}</div>
								</div>

								<div class="transaction-amount-due">
									<div class="tr-money-wrap">
										<span class="currency-indicator">$</span>
										<input class="transaction-due-input has-prefix" type="text" inputmode="decimal" [(ngModel)]="transaction.bal" (click)="$event.stopPropagation()" (blur)="onMoneyInput(transaction, 'bal', vendor.key)" (ngModelChange)="updateVendorTotal(vendor.key)" />
									</div>
								</div>
							</div>
							<div class="vendor-total">
								<h5>Total for {{ vendor.key }}: ${{ vendorTotals[vendor.key] | number: '1.2-2' }}</h5>
							</div>
						</ng-container>
						</div>
						</ng-container>

					</div>

				<!-- Sticky footer — single action bar; phase drives primary action -->
				<div class="run-sticky-footer" *ngIf="showStickyFooter">
					<div class="run-sticky-footer__summary">
						<span class="run-sticky-footer__total">${{ stickyFooterTotal | number:'1.2-2' }}</span>
						<span class="run-sticky-footer__meta" *ngIf="currentPhase === 'select'">
							{{ selectedTransactions }} selected · Discounts ${{ totalDiscount | number:'1.2-2' }}
						</span>
						<span class="run-sticky-footer__meta" *ngIf="currentPhase === 'review'">
							Run #{{ responsePayload?.journal ?? loadedJournal ?? '—' }} · {{ checkCount }} check(s)
						</span>
						<span class="run-sticky-footer__meta run-sticky-footer__meta--posted" *ngIf="currentPhase === 'posted'">
							Posted · Run #{{ postedResult?.journal ?? responsePayload?.journal ?? loadedJournal ?? '—' }}
						</span>
					</div>
					<div class="run-sticky-footer__actions">
						<ng-container *ngIf="currentPhase === 'select'">
							<button
								type="button"
								class="btn btn-outline-secondary btn-sm run-sticky-footer__btn"
								(click)="openRemittancePreview()"
								[disabled]="selectedTransactions === 0 || actionInProgress"
								title="Uses selected lines (bal + discount). After Generate, uses that run instead."
							>
								<i class="fa fa-envelope-o"></i> Preview emails
							</button>
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="exportChecklistPdf()"
								[disabled]="!checklist || actionInProgress || exportingChecklistPdf"
							>
								<span *ngIf="exportingChecklistPdf" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								<i *ngIf="!exportingChecklistPdf" class="fa fa-file-pdf-o"></i> Export PDF
							</button>
							<button
								type="button"
								class="btn btn-outline-success btn-sm run-sticky-footer__btn"
								(click)="exportChecklistXls()"
								[disabled]="!checklist || actionInProgress || exportingChecklistXls"
							>
								<span *ngIf="exportingChecklistXls" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
								<i *ngIf="!exportingChecklistXls" class="fa fa-file-excel-o"></i> Export XLSX
							</button>
							<button
								type="button"
								class="btn btn-outline-success btn-sm run-sticky-footer__btn"
								(click)="saveForReview()"
								[disabled]="selectedTransactions === 0 || actionInProgress"
							>
								<i class="fa fa-save"></i> Save for review
							</button>
							<button
								*ngIf="loadedJournal != null"
								type="button"
								class="btn btn-success btn-sm run-sticky-footer__btn run-sticky-footer__btn--primary"
								(click)="confirmApprove()"
								[disabled]="selectedTransactions === 0 || actionInProgress"
							>
								<i class="fa fa-check-circle"></i> Approve &amp; post
							</button>
							<button
								type="button"
								class="btn btn-primary btn-sm run-sticky-footer__btn run-sticky-footer__btn--primary"
								(click)="createPrint()"
								[disabled]="actionInProgress || selectedTransactions === 0 || hasBlockedVendors"
								[title]="hasBlockedVendors
									? blockedVendorKeys.length + ' vendor(s) net ≤ $0 — fix the highlighted rows before generating.'
									: (selectedTransactions === 0 ? 'Select at least one invoice line.' : 'Generate the payment run')"
							>
								<i class="fa fa-print"></i> Generate payment run
								<span *ngIf="hasBlockedVendors" class="run-sticky-footer__blocked-badge">{{ blockedVendorKeys.length }}</span>
							</button>
						</ng-container>

						<ng-container *ngIf="currentPhase === 'review'">
							<!-- Destructive Discard sits at the far left, away from Approve & post. -->
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="discardGeneratedRun()"
								[disabled]="actionInProgress"
								title="Abandon this run — removes the pending entry; nothing gets posted."
							>
								<i class="fa fa-trash"></i> Discard
							</button>
							<button
								type="button"
								class="btn btn-outline-secondary btn-sm run-sticky-footer__btn"
								(click)="backToEditRun()"
								[disabled]="actionInProgress"
								title="Return to invoice selection — same journal, nothing posted."
							>
								<i class="fa fa-pencil"></i> Back to edit
							</button>
							<button
								type="button"
								class="btn btn-outline-secondary btn-sm run-sticky-footer__btn"
								(click)="openRemittancePreview()"
								[disabled]="actionInProgress"
								title="Uses the generated payment run."
							>
								<i class="fa fa-envelope-o"></i> Preview emails
							</button>
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="printCheck()"
								[disabled]="actionInProgress"
							>
								<i class="fa fa-file-pdf-o"></i> Check PDF
							</button>
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="downloadRemittances()"
								[disabled]="actionInProgress"
								title="Full remittance pages for every check — print on plain paper and attach to mailed checks."
							>
								<i class="fa fa-paperclip"></i> Remittance PDF
							</button>
							<!-- Primary action sits at the far right, gap between it and Discard. -->
							<button
								type="button"
								class="btn btn-success btn-sm run-sticky-footer__btn run-sticky-footer__btn--primary"
								(click)="confirmApprove()"
								[disabled]="actionInProgress"
							>
								<i class="fa fa-check-circle"></i> Approve &amp; post
							</button>
						</ng-container>

						<ng-container *ngIf="currentPhase === 'posted'">
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="printCheck()"
								[disabled]="actionInProgress"
							>
								<i class="fa fa-file-pdf-o"></i> Check PDF
							</button>
							<button
								type="button"
								class="btn btn-outline-danger btn-sm run-sticky-footer__btn"
								(click)="downloadRemittances()"
								[disabled]="actionInProgress"
								title="Full remittance pages for every check — print on plain paper."
							>
								<i class="fa fa-paperclip"></i> Remittance PDF
							</button>
						</ng-container>

						<!-- Plain "Processing…" only when there's no chunked-post in flight. -->
						<span *ngIf="actionInProgress && !postingProgress" class="run-sticky-footer__busy">
							<span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
							Processing…
						</span>

						<!-- Chunked-post progress: live count + bar so big batches show life. -->
						<div *ngIf="postingProgress" class="post-progress">
							<div class="post-progress__line">
								<span class="post-progress__icon"><span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span></span>
								<span class="post-progress__text">
									Posting <b>{{ postingProgress.current }}</b> of <b>{{ postingProgress.total }}</b>
									<span *ngIf="postingProgress.skipped" class="post-progress__skipped">· {{ postingProgress.skipped }} already posted</span>
								</span>
							</div>
							<div class="post-progress__bar">
								<div class="post-progress__bar-fill" [style.width.%]="postingProgress.total ? (postingProgress.current * 100 / postingProgress.total) : 0"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
